<template>
  <div class="container">
    <div class="headerContainer">
      <img src="../../assets/logo.png" class="img" />
      <div class="download-container">
        <div class="text-container">下载效果图</div>
      </div>
    </div>
    <div class="body-container">
      <div class="left-container">
        <div class="item-container">
          <svg class="item-img" aria-hidden="true">
            <use xlink:href="#iconShop_Custom_Commodity" />
          </svg>
          <div class="item-text">商品</div>
        </div>
        <div class="item-container">
          <svg class="item-img" aria-hidden="true">
            <use xlink:href="#iconShop_Custom_Cloud" />
          </svg>
          <div class="item-text">上传</div>
        </div>
      </div>
      <div class="center-container">
        <div class="search-container">
          <input type="text" class="prosearch" placeholder="搜索商品名称" />
        </div>
        <div class="custoized-shoplist">
          <div v-for="(items, index) in custoizedList" :key="index">
            <div class="items-container">
              <div class="shop-title">{{ items.title }}</div>
              <div v-for="(item, index) in items.shopList" :key="index">
                <div class="shop-item"></div>
                <div class="shop-name">{{ item.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right-container">
        <div class="custome">
          <CanvasDrag :imgArr="imgArr" :backImg="data" style="boder:1px dashed red;" />
          <div class="upload">
            <input
              type="file"
              accept="image/jpeg, image/png, imagejpg"
              @change="changeImage($event)"
              class="input-opacity"
            />
            <el-button @click="exportImg">导出素材</el-button>
          </div>
          <div class="url">
            <img :src="url" crossorigin="anonymous" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CanvasDrag from "@/components/CanvasDrag.vue";
import html2canvas from "html2canvas";

export default {
  name: "customized",
  components: { CanvasDrag },
  data() {
    return {
      custoizedList: [
        {
          title: "电子数码",
          shopList: [
            { name: "iPhone 6 " },
            { name: "iPhone 6 " },
            { name: "iPhone 6 " },
            { name: "iPhone 6 " },
            { name: "iPhone 6 " }
          ]
        },
        {
          title: "数码周边",
          shopList: [
            { name: "iPhone 7 " },
            { name: "iPhone 7 " },
            { name: "iPhone 6 " },
            { name: "iPhone 6 " },
            { name: "iPhone 6 " }
          ]
        }
      ],
      url: "",
      imgArr: [],
      data: null
    };
  },
  created() {
    let url =
      "https://senkoo.oss-cn-shanghai.aliyuncs.com/products/WL-20060407200200.jpg";
    this.readUrl(url, o => {
      this.data = o;
    });
  },
  methods: {
    exportImg() {
      // var that = this;
      html2canvas(document.querySelector("#myCanvas"), {
        useCORS: true
      }).then(canvas => {
        this.url = canvas.toDataURL("image/jpeg", 1);
      });
    },
    readUrl(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onload = () => {
        var reader = new FileReader();
        reader.onloadend = () => {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    },
    changeImage(e) {
      const fileObj = new FileReader();
      fileObj.readAsDataURL(e.target.files[0]);
      fileObj.onload = () => {
        this.picReduce(fileObj.result, imgObj => {
          // console.log("imgObj:",fileObj,e.target.files[0], imgObj);
          imgObj.name = e.target.files[0].name
          this.imgArr.push(imgObj);
        });
      };
    },
    picReduce(fileObj, callback) {
      const img = new Image();
      img.src = fileObj;
      img.onload = () => {
        const w = img.width;
        const h = img.height;
        const scale = this.getScale(w, h);
        const maxW = w / scale;
        const maxH = h / scale;
        const imgObj = {
          url: img,
          width: maxW,
          height: maxH
        };
        callback(imgObj);
      };
    },
    getScale(w, h) {
      if (w >= h) {
        if (h <= 120) {
          return 1;
        } else {
          return h / 120;
        }
      } else if (h > w) {
        if (w <= 120) {
          return 1;
        } else {
          return w / 120;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  // height: 1024px;
  height: 100vh;
  background-color: #fff;
  .headerContainer {
    width: 100%;
    height: 64px;
    flex-direction: row;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    .img {
      margin-top: 10px;
      height: 40px;
      padding-left: 24px;
    }
    .download-container {
      width: 160px;
      height: 64px;
      background: rgba(239, 45, 35, 1);
      .text-container {
        height: 64px;
        font-size: 16px;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        line-height: 24px;
        text-align: center;
        margin: 18px 0 20px 0;
      }
    }
  }

  .body-container {
    width: 100%;
    height: calc(100vh - 70px);
    background-color: #fff;
    display: flex;
    .left-container {
      width: 64px;
      height: 100%;
      flex-direction: column-reverse;
      padding-top: 32px;
      border: 1px solid rgba(217, 217, 217, 1);
      .item-container {
        width: 64px;
        height: 64px;
        flex-direction: column-reverse;
        .item-img {
          position: relative;
          width: 15px;
          height: 15px;
          left: 50%;
          transform: translateX(-50%);
        }
        .item-text {
          margin-top: 6px;
          font-size: 12px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);
          line-height: 20px;
          text-align: center;
        }
      }
    }
    .center-container {
      width: 320px;
      height: 100%;
      border: 1px solid rgba(217, 217, 217, 1);
      .search-container {
        width: 320px;
        height: 72px;
        border: 1px solid rgba(217, 217, 217, 1);
        padding: 16px 0 0 16px;
        .prosearch {
          width: 288px;
          height: 40px;
          line-height: 48px;
          top: 40px;
          right: 81px;
          border: 0;
          border: 1px solid rgba(217, 217, 217, 1);
          font-size: 16px;
          padding-left: 10px;
          outline: none;
        }
      }

      .custoized-shoplist {
        width: 320px;
        height: 93%;
        padding: 0 16px 0 16px;
        overflow: scroll;
        .items-container {
          display: inline-flex;
          flex-wrap: wrap;
          justify-content: space-between;
          .shop-title {
            width: 200px;
            font-size: 14px;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.85);
            line-height: 22px;
            margin: 16px 0 16px 0;
            display: inline-flex;
          }
          .shop-item {
            width: 136px;
            height: 136px;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(217, 217, 217, 1);
            margin: 0 0 8px 0;
          }
          .shop-name {
            width: 136px;
            height: 20px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.65);
            line-height: 20px;
            margin: 0 0 8px 0;
          }
        }
      }
    }
    .right-container {
      width: 100%;
      height: 100%;
      border: 1px solid rgba(217, 217, 217, 1);
      position: relative;
      .custome {
        position: absolute;
        top: 0;
        right: 0;
      }
      .url {
        img {
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 100%;
        }
      }
      //    background-color: red;
    }
  }
}
</style>
